import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import translate from '../../../../scripts/core/tools/translate';
import _ from 'lodash';
import environment from '../../../../scripts/environment';
import { VehicleTypeEnum } from '../../../../scripts/core/vehicleType/constants';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class StoreInactiveFactory {
  constructor({options, currentMap}) {
    this.options = options;
    this.currentMap = currentMap;
  }

  getData() {
    const typeFilter = {
      name: 'type',
      position: 3,
      visible: isAuthorized(FeaturePermission.LAYER_STORE_INACTIVE.filterStoreType),
      fields: [{
        title: translate('Common.TypeOfStore'),
        name: 'type',
        dataSource: _.map(environment.get('CONFIG.FILTERS.COMPETITORS_TYPES'), (val) => ({
          text: val,
          value: val
        })),
        value: 'value',
        text: 'text',
        skipAll: true,
        type: 'multiselect'
      }]
    };

    const data = [{
      name: 'category_and_brands',
      data: _.reduce(environment.get('CONFIG.FILTERS.BRANDS_CLASSIFICATION'), (acc, val, key) => {
        _.forEach(val, (v, i) => {
          acc.push({
            CD_CAT: key,
            NM_CAT: translate(key),
            CD_BRAND: v,
            NM_BRAND: v
          });
        });

        return acc;
      }, []),
      position: 1,
      visible: isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterClassification),
      fields: [{
        title: translate('Common.Brand'),
        name: 'brands',
        value: 'CD_BRAND',
        text: 'NM_BRAND',
        type: 'multiselect'
      }]
    }];

    if (environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Car) {
      data[0].fields.unshift({
        title: `${translate('Common.Classification')} ${translate('Common.Brand')}`,
        name: 'classification',
        value: 'CD_CAT',
        text: 'NM_CAT',
        skipAll: true,
        type: 'multiselect'
      });
    }

    data.push(typeFilter);

    data.push({
      name: 'group',
      position: 3,
      visible: isAuthorized(FeaturePermission.LAYER_STORE_INACTIVE.filterGroup),
      fields: [{
        title: translate('Common.Group'),
        name: 'group',
        dataSource: _(environment.get('CONFIG.FILTERS.GROUPS_NAME'))
          .map(val => ({ text: val.text, value: val.text }))
          .orderBy(val => val)
          .value(),
        value: 'value',
        text: 'text',
        skipAll: true,
        type: 'multiselect'
      }]
    });

    data.push({
      name: 'state',
      position: 6,
      visible: isAuthorized(FeaturePermission.LAYER_STORE_INACTIVE.filterUf),
      fields: [{
        title: 'UF',
        name: 'state',
        dataSource: environment.get('CONFIG.STATES'),
        value: 'value',
        text: 'text',
        skipAll: true,
        type: 'multiselect'
      }]
    });

    return data.filter(c => c.visible);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/storeinactive.factory.js